import React from 'react';

interface FormFactorModalProps {
  missingFields: string[];
  onClose: () => void;
  onGoToFormFactor: () => void;
}

const FormFactorModal: React.FC<FormFactorModalProps> = ({
  missingFields,
  onClose,
  onGoToFormFactor,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="pr-8">
          <h3 className="text-orange-500 text-lg font-medium mb-1">
            You need to complete Book Form Factor details before you continue.
          </h3>
          <p className="text-orange-400 text-sm mb-4">
            Here are the missing details:
          </p>

          <ul className="space-y-2 mb-6">
            {missingFields.map((field, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700 text-sm">
                <span className="w-1.5 h-1.5 bg-gray-700 rounded-full"></span>
                {field}
              </li>
            ))}
          </ul>

          <button
            onClick={onGoToFormFactor}
            className="bg-gray-900 text-white px-6 py-2.5 rounded-md hover:bg-gray-800 transition-colors font-medium text-sm flex items-center gap-2"
          >
            Go to Book Form Factor
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormFactorModal;
